import { useLocation } from "react-router-dom";
import HomeResults from "../components/homeResults/homeResults";

export default function HomeResultsPage() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const mostrarMomios = params.get("momios"); // true/false
  const patrocinador = params.get("spon"); // caliente/strendus
  const mostrarBotonApostar = params.get("button"); // true/false
  const version= params.get("country");

  return (
    <HomeResults mostrarMomios={mostrarMomios} patrocinador={patrocinador} mostrarBotonApostar={mostrarBotonApostar} version={version}/>
  )

}